import * as React from 'react';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Translate, { translate } from './Translate';
import Icon from './Icon';
import { FilterStore } from '../stores';

const ClearFiltersButton = styled<any, any>('button')`
    ${propStyles};
`;

ClearFiltersButton.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'body',
    fontWeight: 'normal',
    fontSize: 'sm',
    color: 'gray500',
    bgColor: 'transparent',
    borderStyle: 'none',
    cursor: 'pointer',
    outline: 'none',
    selected: {
        color: 'body',
    },
};

interface ClearFiltersProps {
    theme?: { [property: string]: string | number };
    translations?: { [property: string]: string };
    filterStore?: FilterStore;
}

export const ClearFilters: React.SFC<ClearFiltersProps> = ({
    theme,
    translations,
    filterStore,
    ...props
}) => (
    <ClearFiltersButton
        title={translate(translations, filterStore.clearFiltersLabel)}
        onClick={
            filterStore.filtersActive
                ? filterStore.clearFilters
                : () => undefined
        }
        data-selected={filterStore.filtersActive}
        {...theme.FiltersClearButton}
        {...props}
    >
        <Translate>{filterStore.clearFiltersLabel}</Translate>
        <Icon
            height="1.4em"
            width="1.4em"
            margin="0 0 0 0.25em"
            fileName="ClearFiltersIcon"
            {...theme.ClearFiltersIcon}
        />
    </ClearFiltersButton>
);

export default inject('translations', 'filterStore')(
    observer(withTheme(ClearFilters))
) as any;



// WEBPACK FOOTER //
// ./src/Components/ClearFilters.tsx